(() => {
  const initializeVideo = (video) => {
    if (video.dataset.bannerVideoInitialized === 'true') return;
    video.dataset.bannerVideoInitialized = 'true';

    const wrapper = video.closest('[data-banner-video-wrapper]');
    if (!wrapper) return;

    const toggle = wrapper.querySelector('[data-banner-video-toggle]');
    if (!toggle) return;

    const pauseLabel = toggle.dataset.pauseLabel || 'Pause';
    const playLabel = toggle.dataset.playLabel || 'Play';

    const syncState = () => {
      if (video.paused) {
        toggle.setAttribute('aria-pressed', 'false');
        toggle.textContent = playLabel;
      } else {
        toggle.setAttribute('aria-pressed', 'true');
        toggle.textContent = pauseLabel;
      }
    };

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);

    // Ensure the button reflects initial autoplay state.
    if (video.autoplay && video.muted) {
      video.play().catch(() => {});
    }

    syncState();
  };

  const initScope = (scope) => {
    scope
      .querySelectorAll('video[data-banner-video]')
      .forEach((video) => initializeVideo(video));
  };

  document.addEventListener('DOMContentLoaded', () => {
    initScope(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initScope(event.target);
  });
})();
